//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateComputed } from '../../common/functions/roles-computed-generator';
import exportacao from '../../common/resources/exportacoes';

export default {
  data() {
    return {
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      tipos: [],
      esperar: false,
      headers: [
        { text: '', value: 'acoes', width: '2%', sortable: false },
        { text: this.$tc('label.codigo', 1), value: 'id_externo', sortable: true },
        { text: this.$tc('label.nome', 1), value: 'nome', sortable: true },
        { text: this.$tc('label.ativo', 1), value: 'ind_ativo', sortable: true },
      ],
      pagination: {},
      totalPage: 0,
      searchQuery: '',
      selected: [],
    };
  },
  props: {
    title: String,
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    searchQuery() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
  },
  computed: {
    filteredList() {
      return [];
    },
    ...generateComputed('tipo_linha', [
      'canAccessCRUD',
      'canAccessPage',
    ]),
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
  },
  methods: {
    buscar() {
      if (this.searchQuery) {
        this.pagination.page = 1;
      }

      const params = {
        texto: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };

      this.tipoInvestimentoResources.listar(params).then((response) => {
        this.tipos = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 5E2);
    },
    onEditar(item) {
      this.$emit('PESQUISA_EDITAR', item);
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    mudarOrdenacao(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.tipos.slice();
    },
    ativarDesativarRegistros() {
      this.requestAtivarInativar();
    },
    requestAtivarInativar() {
      if (this.selected && this.selected.length > 0) {
        this.tipoInvestimentoResources.ativarMassa(this.selected)
          .then(() => {
            this.selected = [];
            this.$toast.create(this.$t('message.alteracao_massa_sucesso'), 'snack', 3E3);
            this.filtrar();
          })
          .catch(err => this.$error(this, err));
      }
    },
    exportar() {
      const filtros = {};
      const limit = 500;
      const timeout = 120000;
      const resource = exportacao(this.$http, timeout);
      resource.download('tipo_investimento_simples',
        {
          limit,
          parametrosConsulta: filtros,
        })
        .then(() => {
          this.$toast.create(this.$t('message.exportacao_download'), 'snack', 3E3);
        })
        .catch(() => {
          if (cb) {
            cb();
          }
          this.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
        });
    },
  },
  mounted() {
    this.filtrar();
  },
};



// WEBPACK FOOTER //
// ./src/spa/tipo-investimento/TipoInvestimentoTabela.vue?vue&type=script&lang=js&